import '../stylesheets/frontend/ranking.css.scss'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

import ReactOnRails from 'react-on-rails'
import DeviationRankingTable from '../bundles/components/CurrencyRankingTable/deviation'
import HighLowRankingTable from '../bundles/components/CurrencyRankingTable/highLow'
import TradingVolumeRankingTable from '../bundles/components/CurrencyRankingTable/tradingVolume'

const application = Application.start()
const context = require.context(
  'controllers',
  true,
  /^(?!.*\/admin\/).*_controller\.(js|ts)$/
)
application.load(definitionsFromContext(context))

ReactOnRails.register({
  DeviationRankingTable,
  HighLowRankingTable,
  TradingVolumeRankingTable,
})
